import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" }),
      _createElementVNode("path", { d: "M15.606 12.272a1.25 1.25 0 0 0 .25 1.379l.046.045a1.513 1.513 0 0 1 0 2.144 1.515 1.515 0 0 1-2.144 0l-.046-.045a1.25 1.25 0 0 0-1.378-.25 1.25 1.25 0 0 0-.758 1.144v.128a1.515 1.515 0 1 1-3.03 0v-.068a1.25 1.25 0 0 0-.818-1.144 1.25 1.25 0 0 0-1.38.25l-.045.046a1.515 1.515 0 1 1-2.144-2.144l.046-.046a1.25 1.25 0 0 0 .25-1.378 1.25 1.25 0 0 0-1.144-.758h-.129a1.515 1.515 0 1 1 0-3.03h.068a1.25 1.25 0 0 0 1.144-.818 1.25 1.25 0 0 0-.25-1.38L4.1 6.303a1.515 1.515 0 1 1 2.144-2.144l.045.046a1.25 1.25 0 0 0 1.379.25h.06a1.25 1.25 0 0 0 .758-1.144v-.129a1.515 1.515 0 0 1 3.03 0v.068a1.25 1.25 0 0 0 .758 1.144 1.25 1.25 0 0 0 1.379-.25l.045-.045a1.514 1.514 0 0 1 2.589 1.072 1.51 1.51 0 0 1-.445 1.072l-.045.045a1.25 1.25 0 0 0-.25 1.379v.06a1.25 1.25 0 0 0 1.144.758h.128a1.515 1.515 0 1 1 0 3.03h-.068a1.25 1.25 0 0 0-1.144.758" })
    ], -1)
  ])))
}
export default { render: render }